import { render, staticRenderFns } from "./SalaryBill.vue?vue&type=template&id=f1733e84&scoped=true"
import script from "./SalaryBill.vue?vue&type=script&lang=js"
export * from "./SalaryBill.vue?vue&type=script&lang=js"
import style0 from "./SalaryBill.vue?vue&type=style&index=0&id=f1733e84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1733e84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1733e84')) {
      api.createRecord('f1733e84', component.options)
    } else {
      api.reload('f1733e84', component.options)
    }
    module.hot.accept("./SalaryBill.vue?vue&type=template&id=f1733e84&scoped=true", function () {
      api.rerender('f1733e84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/SalaryBill.vue"
export default component.exports